// Small SVG sparkline of the account's historical daily boost credits (equity chart).
// Purely informational — sits above the daily-code input.

export default function BoostHistoryChart({ history }) {
  const rows = Array.isArray(history) ? history : [];
  const w = 560;
  const h = 90;
  const pad = 8;

  if (rows.length < 2) {
    return (
      <div className="mb-3 border border-white/10 bg-ink/40 px-4 py-6 text-center text-[10px] uppercase tracking-[0.25em] text-white/35">
        Redeem your first boost — your history curve appears here.
      </div>
    );
  }

  const vals = rows.map((r) => Number(r.bonus || 0));
  const min = Math.min(0, ...vals);
  const max = Math.max(...vals) || 1;
  const range = max - min || 1;
  const cw = (w - pad * 2) / (rows.length - 1);
  const y = (v) => h - pad - ((v - min) / range) * (h - pad * 2);
  const pts = vals.map((v, i) => `${(pad + i * cw).toFixed(1)},${y(v).toFixed(1)}`).join(" L ");
  const area = `M ${pad},${h - pad} L ${pts} L ${(w - pad).toFixed(1)},${h - pad} Z`;

  const total = vals.reduce((s, v) => s + v, 0);
  const last = vals[vals.length - 1];

  return (
    <div className="mb-3 border border-gold/20 bg-gold/[0.03] p-4" data-testid="boost-history-chart">
      <div className="mb-2 flex items-baseline justify-between">
        <p className="text-[10px] uppercase tracking-[0.25em] text-gold/80">Boost history</p>
        <p className="font-tabular text-[11px] text-white/60">
          <span className="text-[#00FF41]">+${total.toFixed(2)}</span>
          <span className="mx-2 text-white/25">·</span>
          <span>last +${last.toFixed(2)}</span>
        </p>
      </div>
      <svg viewBox={`0 0 ${w} ${h}`} className="h-16 w-full">
        <path d={area} fill="#D4AF37" opacity="0.14" />
        <path d={`M ${pts}`} fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinejoin="round" />
        {vals.map((v, i) => (
          <circle
            key={i}
            cx={pad + i * cw}
            cy={y(v)}
            r="1.8"
            fill="#D4AF37"
          />
        ))}
      </svg>
    </div>
  );
}
